// eslint-disable-next-line no-restricted-imports
import debounce from 'lodash/debounce'
import Mark from 'mark.js'

import { HIGHLIGHT_CLASS } from './constants'

type MarkOptions = {
  acrossElements?: boolean
  separateWordSearch?: boolean
  exclude?: string[]
}

type MarkParams = {
  marker: Mark
  keyword: string
  done?: () => void
}

const SKIPPED_ELEMENTS = [
  'mark',
  'mark *',
  'button',
  '.DoctrineTools-btn-text',
  '.dropdown-item',
  '[data-doctrine-footnote] *',
]

export const defaultMarkOptions: MarkOptions = {
  acrossElements: true,
  separateWordSearch: false,
  exclude: SKIPPED_ELEMENTS,
}

const mark = ({ marker, keyword, done }: MarkParams) => {
  marker.unmark({
    done: () => {
      marker.mark(keyword, {
        ...defaultMarkOptions,
        className: HIGHLIGHT_CLASS,
        done,
      })
    },
  })
}

export const debounceSearch = debounce(mark, 300)
